/**
 * Icon Helper Utilities
 * Converts icon names (strings) to JSX components
 */

import React from "react";
import {
  Users,
  Car,
  ParkingCircle,
  ArrowLeftRight,
  Construction,
  UtensilsCrossed,
  Bed,
  Users2,
  TreePine,
  Package,
  ShieldAlert,
  Radio,
  ThermometerSun,
  Stethoscope,
  Microscope,
  Plane,
  MapPin,
  Camera,
  Cog,
} from "lucide-react";

// Icon component mapping
const iconMap: Record<string, React.ComponentType<any>> = {
  Users,
  Car,
  ParkingCircle,
  ArrowLeftRight,
  Construction,
  UtensilsCrossed,
  Bed,
  Users2,
  TreePine,
  Package,
  ShieldAlert,
  Radio,
  ThermometerSun,
  Stethoscope,
  Microscope,
  Plane,
  MapPin,
  Camera,
  Cog,
};

/**
 * Get icon JSX element from icon name
 * @param iconName - Name of the icon (e.g., "Users", "Car")
 * @param className - Optional className for the icon (default: "w-6 h-6")
 * @returns JSX element or null if icon not found
 */
export const getJobIcon = (
  iconName: string,
  className: string = "w-6 h-6"
): React.ReactNode => {
  const IconComponent = iconMap[iconName];
  if (!IconComponent) {
    console.warn(`Icon "${iconName}" not found in icon map`);
    return null;
  }
  return <IconComponent className={className} />;
};
